import { ListBox, Table } from '@flos/react-ui';
import type { RowInformation } from '../../../config/flavourConfig';
import { getClaimsHistoryCoverableDetailsConfig } from '../utils/CoverableDetailsClaimsHistoryUtil';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import TableRow from '../../../shared_components/TableRow/TableRow';
import { useHippoText } from '../../../hooks/useHippoText';
import useWindowSize from '../../../hooks/useWindowSize';

const CoverableDetailsClaimsHistoryInformation = ({
    coverable
}: {
    coverable: CoverableDTO;
}): React.JSX.Element => {
    const { isMobileDevice } = useWindowSize();
    const listBoxIsOpen = !isMobileDevice;
    const getHippoText = useHippoText();
    const componentProperties = getClaimsHistoryCoverableDetailsConfig(coverable, getHippoText);
    const coverableProperties = componentProperties?.rowsInformation.filter(
        (tableInfo) => !tableInfo.hidden
    );
    if (!coverable || !coverableProperties || coverableProperties.length === 0) {
        return <></>;
    }
    return (
        <div className="u-spacing-inset-m--stretch-max">
            <ListBox title={componentProperties?.title ?? ''} isOpen={listBoxIsOpen}>
                <Table mobileDirection="horizontal" className="u-spacing-stack-sm">
                    <Table.Body>
                        {coverableProperties.map((rowInfo: RowInformation) => {
                            return <TableRow key={rowInfo.name} rowInfo={rowInfo} />;
                        })}
                    </Table.Body>
                </Table>
            </ListBox>
        </div>
    );
};

export default CoverableDetailsClaimsHistoryInformation;
